"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextboxGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _textbox = require("./textbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextboxGroup = function TextboxGroup(props) {
  var prefix = props.prefix,
      suffix = props.suffix,
      outerClassName = props.outerClassName,
      outerStyle = props.outerStyle,
      disabled = props.disabled,
      hasError = props.hasError,
      rest = _objectWithoutProperties(props, ["prefix", "suffix", "outerClassName", "outerStyle", "disabled", "hasError"]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sb-textbox-group', outerClassName, {
      'has-error': hasError
    }),
    style: outerStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sb-textbox-prefix', {
      disabled: disabled
    })
  }, prefix), /*#__PURE__*/_react.default.createElement(_textbox.Textbox, _extends({}, rest, {
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sb-textbox-suffix', {
      disabled: disabled
    })
  }, suffix));
};

exports.TextboxGroup = TextboxGroup;
TextboxGroup.propTypes = {
  disabled: _propTypes.default.bool,
  outerClassName: _propTypes.default.string,
  prefix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  suffix: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  outerStyle: _propTypes.default.object // eslint-disable-line

};
TextboxGroup.defaultProps = {
  disabled: false,
  outerClassName: '',
  prefix: null,
  suffix: null,
  hasError: false,
  outerStyle: {}
};
//# sourceMappingURL=textbox-group.js.map